"use client";
import "../../../../chunk-3GWWZKX7.js";
const dashToPascalCase = (str) => str.toLowerCase().split("-").map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const camelToDashCase = (str) => str.replace(/([A-Z])/g, (m) => `-${m[0].toLowerCase()}`);
export {
  camelToDashCase,
  dashToPascalCase
};
